import { call } from 'redux-saga/effects';
import appHandler from '../appHandler';
import { APIHandler, handleError } from '../commonHandlers';
import {
  handleGetDepositionsSuccess,
  handleGetDepositionSuccess,
  handleGetExhibitSuccess,
  handleGetFinalSuccess,
  handleGetInvoledPartiesSuccess,
  handleGetProductionSuccess,
  handleGetRequesterSuccess,
} from './depositionHandler';

function* getDepositions(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetDepositionsSuccess, handleError);
}

function* getDepositionById(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetDepositionSuccess, handleError);
}

function* createDeposition(api, action) {
  yield call(APIHandler, api, action);
}

function* updateDeposition(api, action) {
  yield call(APIHandler, api, action);
}

function* deleteDeposition(api, action) {
  yield call(APIHandler, api, action);
}

function* approveDeposition(api, action) {
  yield call(APIHandler, api, action);
}

function* completeDeposition(api, action) {
  yield call(APIHandler, api, action);
}

function* rejectDeposition(api, action) {
  yield call(APIHandler, api, action);
}

function* grantAccessFinalDeposition(api, action) {
  yield call(APIHandler, api, action);
}

function* lockDeposition(api, action) {
  yield call(APIHandler, api, action);
}

function* getDepositionExhibitFiles(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetExhibitSuccess, handleError);
}

function* getDepositionProductionFiles(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetProductionSuccess, handleError);
}

function* getDepositionRequester(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetRequesterSuccess, handleError);
}

function* getDepositionInvoledParties(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetInvoledPartiesSuccess, handleError);
}

function* getDepositionFinalFiles(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetFinalSuccess, handleError);
}

function* renameFile(api, action) {
  yield call(APIHandler, api, action);
}

function* deleteFile(api, action) {
  yield call(APIHandler, api, action);
}

function* renameFinalFile(api, action) {
  yield call(APIHandler, api, action);
}

export default {
  getDepositions,
  getDepositionById,
  createDeposition,
  updateDeposition,
  deleteDeposition,
  approveDeposition,
  rejectDeposition,
  completeDeposition,
  grantAccessFinalDeposition,
  lockDeposition,
  getDepositionExhibitFiles,
  getDepositionFinalFiles,
  getDepositionProductionFiles,
  renameFile,
  deleteFile,
  renameFinalFile,
  getDepositionRequester,
  getDepositionInvoledParties,
};
